<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="col-sm-12">
                    <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
                        <div class="row">
                            <div class="col-md-12">
                                <vs-breadcrumb align="left" :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'Training',
                      url: '/#/dashboard/Admin/training',
                      active: true
                    }
                  ]"></vs-breadcrumb>
                                <div class="heading mt-3">
                                    <h3 class="text-secondary">Training</h3>
                                </div>
                                <div class="alert alert-success" v-if="success">
                                    {{ success }}
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent="TrainingCreationForm">
                            <div class="form-row">
                                <h6 class="sub-frm-title">Add Subprogram(s)</h6>

                                <div class="col-sm-12">
                                    <b-card v-if="isForm" style="border: 1px dotted #07a7e14f;">
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <label style="color:#000;font-weight:700;">
                                                        Select Sub Program
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state" class="text-capitalize" v-model="subprogram" :settings="subProgramSetting" :searchable="true">
                                                        <option v-for="(item,index) in subprogramsArray" :key="index" :value="item.id" class="text-capitalize">
                                                            {{item.title}}
                                                        </option>
                                                    </selectize>
                                                </div>

                                                <div class="col-sm-6">
                                                    <label style="color:#000;font-weight:700;">
                                                        Select Project
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state" class="text-capitalize" v-model="project" :settings="projectSetting" :searchable="true">
                                                        <option v-for="(item,index) in projectsArray" :key="index" :value="item.id" class="text-capitalize">
                                                            {{item.title}}
                                                        </option>
                                                    </selectize>
                                                </div>

                                                <div class="col-sm-6">
                                                    <label style="color:#000;font-weight:700;">
                                                        Assign To Advisor
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state" class="text-capitalize" v-model="advisor" :settings="advisorSetting" :searchable="true">
                                                        <option v-for="(item,index) in advisorArray" :key="index" :value="item.id" class="text-capitalize">
                                                            {{item.name}}
                                                        </option>
                                                    </selectize>
                                                </div>

                                                <div class="col-md-12 col-lg-12" style="margin-top:30px;">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="trainingtitle" type="text" placeholder=" " />
                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;"></i>
                                                        </span>
                                                        <label class="lbl-label">
                                                            Event Title
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <!-- add button starts-->
                                                    <b-button type="submit" class="save-btn" variant="primary">Add</b-button>
                                                    <!-- add button ends -->
                                                </div>
                                            </div>
                                        </div>
                                    </b-card>
                                    <!-- Edit form starts here -->
                                    <b-card v-if="isEditForm == true" style="border: 1px dotted #07a7e14f;">
                                        <form @submit.prevent="submitEditForm">
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <label>Sub Program</label>
                                                        <selectize id="select-state" class="text-capitalize" v-model="subprogram" :settings="subProgramSetting" :searchable="true">
                                                            <option v-for="(item,index) in subprogramsArray" :key="index" :value="item.id" class="text-capitalize">
                                                                {{item.title}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Project</label>
                                                        <selectize id="select-state" class="text-capitalize" v-model="project" :settings="projectSetting" :searchable="true">
                                                            <option v-for="(item,index) in projectsArray" :key="index" :value="item.id" class="text-capitalize">
                                                                {{item.title}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <label>Assign To</label>
                                                        <selectize id="select-state" class="text-capitalize" v-model="advisor" :settings="advisorSetting" :searchable="true">
                                                            <option v-for="(item,index) in advisorArray" :key="index" :value="item.id" class="text-capitalize">
                                                                {{item.name}}
                                                            </option>
                                                        </selectize>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12" style="margin-top:30px;">
                                                        <div class="floating-label">
                                                            <input class="floating-input form-control" v-model="trainingtitle" type="text" placeholder=" " />
                                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                <i class="material-icons" style="font-size: 20px;"></i>
                                                            </span>
                                                            <label class="lbl-label">Event Title</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <input type="hidden" v-model="trainingId" />
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <!-- add button starts-->
                                                        <b-button pill type="submit" class="save-btn" variant="primary">Update</b-button>
                                                        <b-button pill v-if="!isForm" @click="closeEditForm" variant="outline-info">Cancel</b-button>
                                                        <!-- add button ends -->
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </b-card>
                                    <!-- // End of Edit form -->
                                </div>

                                <div class="col-sm-12">
                                    <!-- new form popup starts -->
                                    <b-card>
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-6 text-left">
                                                    <h2 style="color:#06a6e0">
                                                        List of All-Time Trainings
                                                    </h2>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="table-responsive">
                                                        <table class="table table-hover">
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Event Title</th>
                                                                <th>code</th>
                                                                <th>Project Title</th>
                                                                <th>Sub Program</th>
                                                                <th>Added On</th>
                                                                <th>Action</th>
                                                            </tr>
                                                            <tr v-for="(item, index) in items" v-bind:key="item.id">
                                                                <td>{{index+1}}</td>
                                                                <td class="text-capitalize">
                                                                    {{item.title ? item.title : "No Title" }}
                                                                </td>
                                                                <td v-if="item.training_code != ''">
                                                                    {{item.training_code ? item.training_code : "No code"}}
                                                                </td>
                                                                <td v-else>
                                                                    <code>Null</code>
                                                                </td>
                                                                <td class="text-capitalize">
                                                                    {{item.project && item.project.title ? item.project.title : "No Title"}}
                                                                </td>
                                                                <td class="text-capitalize">
                                                                    {{item.subprogram && item.subprogram.title ? item.subprogram.title : "No Title"}}
                                                                </td>
                                                                <td>{{formatDate2(item.createdAt)}}</td>
                                                                <td>
                                                                    <a @click="editRecord(item.id)">
                                                                        <vs-icon class="mr-0" icon="edit" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                    </a>
                                                                    <a @click="deleteRecord(item.id)">
                                                                        <vs-icon class="mr-0" icon="delete" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card>

                                    <!-- new form popup ends -->
                                </div>
                            </div>
                        </form>
                        <!-- save button starts-->
                        <!-- <a href="#" class="save-btn btn btn-info">Save</a> -->
                        <!-- save button ends -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Selectize from "vue2-selectize";
import {
    formatDate2
} from "@/utils/DateFormate";


export default {
    data: () => ({
        isSidebar: false,
        isForm: true,
        isFormData: false,
        isEditForm: false,
        errors: [],
        formArr: 1,
        success: "",
        subprogram: "",
        selected: "",
        subprogramsArray: [],
        subProgramSetting: {
            maxItems: 1,
            searchField: ["title"],
            placeholder: "Select sub program here"
        },
        advisorArray: [],
        advisorSetting: {
            maxItems: 1,
            searchField: ["name"],
            placeholder: "Select advisor here"
        },
        projectsArray: [],
        projectSetting: {
            maxItems: 1,
            searchField: ["title"],
            placeholder: "Select project here"
        },
        allTrainigs: [],
        items: [],
        project: "",
        advisor: "",
        trainingtitle: "",
        select1Normal: "",
        select1: 1
    }),
    watch: {
        subprogram(val) {
            if (val != '') {
                this.showSubProjects(val);
            }
        }
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.allTrainig();
        // Set the initial number of items
        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/subprograms/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.subprogramsArray = response.data;
            });

        this.openLoading();
        axios
            .get(localStorage.getItem("BASE_PATH") + "/advisor/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.advisorArray = response.data;
            });
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        Selectize
    },
    methods: {
        formatDate2,
        // this will show projects depends on subprogram
        showSubProjects: function showSubProjects(subId) {
            this.openLoading();
            this.projectsArray = [];
            axios.get(localStorage.getItem("BASE_PATH") + "/admin/projects/subprogram/" + subId + "/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.projectsArray = response.data;
                });
        },

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {

            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        allTrainig: function allTrainig() {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/admin/training/all/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.items = response.data;
                });
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/training/" + id + "/edit")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.subprogram = response.data.subprogram_id;
                        this.project = response.data.project_id;
                        this.trainingtitle = response.data.title;
                        this.advisor = response.data.advisor_id;
                        this.trainingId = response.data.id;
                    }
                });
        },
        deleteRecord(id) {
            // alert("ID '" +id+ "' is being deleted.");
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(localStorage.getItem("BASE_PATH") + "/training/delete", {
                                id: id
                            })
                            .then(response => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg("Record has been deleted successfully!");
                                    this.allTrainig();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        TrainingCreationForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.subprogram) {
                this.inValid.push("Please select Sub Program.");
            }
            if (!this.project) {
                this.inValid.push("Please select Project.");
            }
            if (!this.trainingtitle) {
                this.inValid.push("Please enter Event Title.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
            let self = this;
            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/admin/create/training", {
                        program_id: this.subprogram,
                        project_id: this.project,
                        trainingtitle: this.trainingtitle,
                        advisor_id: this.advisor
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been saved successfully!");
                            self.resetForm();
                            self.allTrainig();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        // This will update record
        // This will submit form
        submitEditForm(e) {
            e.preventDefault();
            if (this.subprogram == "" && this.trainingtitle == "") {
                this.error = "All fields are required. Fill out all fields, please!";
            } else {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/training/update", {
                        program_id: this.subprogram,
                        project_id: this.project,
                        trainingtitle: this.trainingtitle,
                        advisor_id: this.advisor,
                        id: this.trainingId
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainig();
                            self.closeEditForm();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            (this.subprogram = ""),
            (this.project = ""),
            (this.trainingtitle = ""),
            (this.advisor = "");
        },
        addForms() {
            this.formArr++;
        },
        removeForms: function () {
            this.formArr--;
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        }
    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.addnew-btn {
    font-size: 12px;
    box-shadow: none;
    border-color: #6c757d;
    background-color: #6c757d;
    float: right;
    margin: 10px 0px;
}

.save-btn {
    box-shadow: none;
    font-size: 12px;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 5px;
}

.delete-btn {
    font-size: 12px;
    box-shadow: none;
    /* border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61); */
    float: right;
    margin: 10px 0px 0px 5px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #ffffff;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: #000;
    font-weight: 700;
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.display-table ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.display-table li {
    float: left;
    padding: 5px 5px;
}

.display-table li a {
    cursor: inherit;
    font-size: 14px;
    display: block;
    color: #747679;
    text-align: center;
    padding: 5px;
    text-decoration: none;
    background-color: #f1f1f1;
}

.tbl-head th {
    font-weight: 400 !important;
    color: rgba(7, 167, 225, 0.61);
}

.display-table {
    /* margin-bottom: 0px !important; */
    color: #8e8e8e;
}

.display-table th,
.display-table td {
    padding: 5px 10px !important;
    /* border: 1px dotted #07a7e14f; */
}
</style><style>
.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #f4f4f4 !important;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: #000 !important;
    font-weight: 700 !important;
    padding: 0px 5px;
}
</style>
